import { createServerFn } from "@tanstack/react-start";
import {
  getCookie,
  getRequestUrl,
  setCookie,
} from "@tanstack/react-start/server";
import { localeCookieName, normalizeLocale } from "./locale";

const oneYearInSeconds = 60 * 60 * 24 * 365;

function getLocaleCookieOptions() {
  const requestUrl = getRequestUrl({ xForwardedProto: true });

  return {
    path: "/",
    maxAge: oneYearInSeconds,
    sameSite: "lax" as const,
    secure: requestUrl.protocol === "https:",
  };
}

export const getLocalePreference = createServerFn({ method: "GET" }).handler(
  () => ({
    locale: normalizeLocale(getCookie(localeCookieName)),
  })
);

export const setLocalePreference = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => {
    const locale =
      typeof data === "object" && data !== null && "locale" in data
        ? (data as { locale?: unknown }).locale
        : undefined;

    return { locale: normalizeLocale(locale) };
  })
  .handler(({ data }) => {
    setCookie(localeCookieName, data.locale, getLocaleCookieOptions());

    return { locale: data.locale };
  });
